import styled from 'styled-components'

export const NotificationBoxWrapper = styled.div`
  padding: 20px;
  width: 100%;
  background-color: #f4f4f8;
  cursor: not-allowed;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
  p {
    color: #333;
    font-size: 16px;
  }
`
